module.exports = __webpack_public_path__ + "static/logo-ut-web-b7f5cc254f8f8aa479567125c212f5a5.png";